<app-loading-generico [loadingGenerico]="alertLoading"></app-loading-generico>
<app-success-generico [successGenerico]="alertSucesso" (alertFechou)="fecharAlertSucesso($event)"
  alertMessage="As edições que você realizou foram salvas. Fique à vontade para continuar navegando ou realizar outras ações."
  alertTitle="Alterações salvas com o sucesso!">
</app-success-generico>
<app-alert-descartar-alteracoes [(show)]="showAlertDescartarAlteracoes" (confirmouDescarte)="descartarAlteracoes()"></app-alert-descartar-alteracoes>
<app-error-generico [errorGenerico]="alertError" (alertErrorFechou)="fecharAlertError($event)"></app-error-generico>

@if (formularioEmpresa) {
  <form [formGroup]="formularioEmpresa" class="row">
    <div class="col-12 col-md-12 col-lg-8">
      <div class="mb-4">
        <label class="label-menor" for="inptRazaoSocial">RAZÃO SOCIAL</label>
        <input type="text" class="form-control" id="inptRazaoSocial" formControlName="nmRazaosEmp" placeholder="Razão social">
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-4">
      <div class="mb-4">
        <label class="label-menor" for="inptNomeFantasia">NOME FANTASIA</label>
        <input type="text" class="form-control" id="inptNomeFantasia" formControlName="nmFantasEmp" placeholder="Nome fantasia">
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-8">
      <div class="mb-4">
        <label class="label-menor" for="slctRamoAtividade">RAMO DE ATIVIDADE</label>
        <app-select
          [form]="formularioEmpresa"
          name="idRamatiRat"
          id="slctRamoAtividade"
          [options]="ramosAtividadeApi"
          optionValue="idRamoAtividade"
          optionText="descricao">
        </app-select>
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-2">
      <div class="mb-4">
        <label class="label-menor text-nowrap" for="inptInscricaoEstadual">INSCRIÇÃO ESTADUAL</label>
        <input type="text" class="form-control" id="inptInscricaoEstadual" formControlName="cdIeourgEmp" placeholder="Ex: 123456">
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-2">
      <div class="mb-4">
        <label class="label-menor text-nowrap" for="inptInscricaoMunicipal">INSCRIÇÃO MUNICIPAL</label>
        <input type="text" class="form-control" id="inptInscricaoMunicipal" formControlName="cdImunicEmp" placeholder="Ex: 123456">
      </div>
    </div>
    <div class="d-flex container-fluid justify-content-end">
      @if (formularioEmpresa.dirty) {
        <button (click)="showOrHideAlertDescartarAlteracoes()" class="botao-outline px-4 me-3">CANCELAR</button>
      }
      @if (!formularioEmpresa.dirty) {
        <button class="botao-outline px-4 me-3" routerLink="/home">CANCELAR</button>
      }
      <button class="botao px-4" (click)="atualizarDadosEmpresa()" id="btnSalvar"
      [title]="formularioEmpresa.dirty ? 'Salvar alterações' : 'Modifique algum campo para poder atualizar os dados'" [ngClass]="{
        'disabled':
          !formularioEmpresa.valid
          || !formularioEmpresa.dirty
          || !('CadastrosDadosDaEmpresa' | usuarioPermissao:'Alterar' | async)
        }" [disabled]="!formularioEmpresa.valid
          || !formularioEmpresa.dirty
          || !('CadastrosDadosDaEmpresa' | usuarioPermissao:'Alterar' | async)">SALVAR ALTERAÇÕES</button>
    </div>
  </form>
}

<!-- CARREGAMENTO EMPRESAS -->
@if (detalhesEmpresa === null) {
  <div>
    <div class="text-center">
      <output class="spinner-border c-primary">
        <span class="visually-hidden">Consultando dados da empresa ...</span>
      </output>
    </div>
    <p class="legenda-spinner">Consultando dados da empresa ...</p>
  </div>
}

<!-- CASO DE ERRO EMPRESAS -->
@if (detalhesEmpresa === false) {
  <div class="text-center">
    <img src="/assets/img/erro.png" width="200px" alt="Erro">
    <p class="legenda-erro">Ocorreu um erro na consulta dos dados da empresa.</p>
  </div>
}
